export const FetchPreferencesMutation = () => {
    const query = `
    query{
      preferences{
        paymentAlerts
        reports{
          label,
          value
        }
      }
    }
    `
    return query
  }


export const SetDefaultPreferencesMutation = () => {
  const mutation = `
  mutation{
    setDefaultPreferences{
      success
      preferences{
          paymentAlerts
          reports{
            label,
            value
          }
        }
    }
  }
  `
  return mutation
}

export const UpdatePreferencesMutation = (paymentAlerts, reports) => {
  const mutation = `
    mutation{
        updatePreferences(paymentAlerts:${paymentAlerts}, reports:${JSON.stringify(reports)}){
        preferences{
          paymentAlerts
          reports{
            label,
            value
          }
        }
    }
  }
  `
  return mutation
}
